import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { HourlyFootfallPrediction } from '../../../models/prediction/HourlyFootfallPrediction';
import { DailyFootfallPrediction } from '../../../models/prediction/DailyFootfallPrediction';
import {
  FootfallHourlyPredictionResponse,
  FootfallPredictionResponse
} from '../../../../interfaces/response/PredictionsResponses';

/**
 * An adapter converts daily prediction HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class FootfallPredictionAdapter implements Adapter<DailyFootfallPrediction> {

  /**
   * Converts daily prediction HTTP response to {@link DailyFootfallPrediction}.
   * @param item daily prediction HTTP response.
   */
  adapt(item: FootfallPredictionResponse): DailyFootfallPrediction {
    const adapter: Adapter<HourlyFootfallPrediction> = new FootfallHourlyPredictionAdapter();

    return new DailyFootfallPrediction(
      item.date,
      item.hourlyPredictions.map(hourlyPrediction => adapter.adapt(hourlyPrediction))
    );
  }
}

/**
 * An adapter converts hourly prediction HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class FootfallHourlyPredictionAdapter implements Adapter<HourlyFootfallPrediction> {

  /**
   * Converts hourly prediction HTTP response to {@link HourlyFootfallPrediction}.
   * @param item hourly prediction HTTP response.
   */
  adapt(item: FootfallHourlyPredictionResponse): HourlyFootfallPrediction {
    return new HourlyFootfallPrediction(
      item.hour,
      item.prediction
    );
  }
}
